import { t as e } from "./notification-cuDCu4_f.js";
import { ActionIcon as t, Avatar as n, Badge as r, Box as i, Button as a, Collapse as o, Container as s, Divider as c, Drawer as l, Flex as u, Grid as d, Group as f, Menu as p, Modal as m, Pagination as h, Paper as g, Progress as _, Select as v, Skeleton as y, Stack as b, Table as x, Text as S, TextInput as C, Textarea as w, Title as T, Tooltip as E } from "@mantine/core";
import { Children as D, Fragment as O, forwardRef as k, isValidElement as A, startTransition as ee, useCallback as j, useEffect as M, useMemo as te, useRef as ne, useState as N } from "react";
import { Fragment as P, jsx as F, jsxs as I } from "react/jsx-runtime";
import { IconAdjustments as L, IconArrowLeft as R, IconCheck as re, IconChevronDown as z, IconChevronLeft as B, IconChevronRight as ie, IconChevronUp as V, IconDeviceFloppy as H, IconDots as ae, IconEdit as U, IconInfoCircle as W, IconRefresh as oe, IconSearch as se, IconX as G } from "@tabler/icons-react";
import { parseFhirInstantForDisplay as K } from "@benchmark/core/utils";
import { useNavigate as ce } from "react-router";
import { toE164US as le } from "@benchmark/core/adapters";
var q = {
	container: "_container_1dh1r_2",
	header: "_header_1dh1r_9",
	actionsHeader: "_actionsHeader_1dh1r_16",
	searchContainer: "_searchContainer_1dh1r_23",
	searchIcon: "_searchIcon_1dh1r_29",
	expandedSearch: "_expandedSearch_1dh1r_37",
	expandSearch: "_expandSearch_1dh1r_1",
	filterIcon: "_filterIcon_1dh1r_54",
	filterBadge: "_filterBadge_1dh1r_63",
	filtersIndicator: "_filtersIndicator_1dh1r_75",
	filtersSection: "_filtersSection_1dh1r_83",
	slideDown: "_slideDown_1dh1r_1",
	title: "_title_1dh1r_101",
	addButton: "_addButton_1dh1r_106",
	table: "_table_1dh1r_112",
	tableHeader: "_tableHeader_1dh1r_116",
	tableRow: "_tableRow_1dh1r_127",
	tableCell: "_tableCell_1dh1r_136",
	actionsHeaderCell: "_actionsHeaderCell_1dh1r_142",
	actionsCell: "_actionsCell_1dh1r_149",
	actionButton: "_actionButton_1dh1r_157",
	sortIcon: "_sortIcon_1dh1r_166",
	footer: "_footer_1dh1r_175"
}, ue = k(({ value: e, onChange: t, onBlur: n, ...r }, i) => {
	let a = j((e) => {
		let r = e.currentTarget.value.trim();
		if (r !== e.currentTarget.value) {
			let n = {
				...e,
				target: Object.assign(e.target, { value: r }),
				currentTarget: Object.assign(e.currentTarget, { value: r })
			};
			t?.(n);
		}
		n?.(e);
	}, [t, n]);
	return /* @__PURE__ */ F(C, {
		ref: i,
		value: e || "",
		onChange: t,
		onBlur: a,
		...r
	});
});
ue.displayName = "TrimmedTextInput";
// src/components/atomic/loading/SkeletonCells.tsx
var J = (e) => {
	let t = [
		"65%",
		"75%",
		"60%",
		"70%",
		"50%"
	];
	return t[e % t.length];
}, de = ({ width: e, index: t = 0 }) => /* @__PURE__ */ F(y, {
	height: 16,
	width: e || J(t)
}), fe = ({ index: e = 0 }) => /* @__PURE__ */ F(y, {
	height: 16,
	width: J(e)
}), pe = ({ index: e = 0 }) => /* @__PURE__ */ F(y, {
	height: 24,
	width: J(e),
	radius: "xl"
}), me = ({ index: e = 0 }) => /* @__PURE__ */ I(f, {
	gap: "sm",
	children: [/* @__PURE__ */ F(y, {
		height: 40,
		width: 40,
		radius: "xl"
	}), /* @__PURE__ */ I(b, {
		gap: 4,
		children: [/* @__PURE__ */ F(y, {
			height: 16,
			width: J(e)
		}), /* @__PURE__ */ F(y, {
			height: 12,
			width: J(e + 1)
		})]
	})]
}), he = ({ index: e = 0 }) => /* @__PURE__ */ I(f, {
	gap: "sm",
	align: "flex-start",
	wrap: "nowrap",
	children: [/* @__PURE__ */ F(y, {
		height: 40,
		width: 40,
		radius: "xl"
	}), /* @__PURE__ */ I(b, {
		gap: 2,
		style: { flex: 1 },
		children: [
			/* @__PURE__ */ F(y, {
				height: 16,
				width: J(e)
			}),
			/* @__PURE__ */ F(y, {
				height: 12,
				width: J(e + 1)
			}),
			/* @__PURE__ */ F(y, {
				height: 12,
				width: J(e + 2)
			})
		]
	})]
}), ge = ({ index: e = 0 }) => /* @__PURE__ */ I(b, {
	gap: 2,
	children: [
		/* @__PURE__ */ F(y, {
			height: 16,
			width: J(e)
		}),
		/* @__PURE__ */ F(y, {
			height: 12,
			width: J(e + 1)
		}),
		/* @__PURE__ */ F(y, {
			height: 12,
			width: J(e + 2)
		})
	]
}), _e = ({ index: e = 0 }) => /* @__PURE__ */ F(b, {
	gap: 4,
	children: /* @__PURE__ */ F(y, {
		height: 16,
		width: J(e)
	})
}), ve = ({ index: e = 0 }) => /* @__PURE__ */ I(f, {
	gap: 4,
	align: "center",
	children: [
		/* @__PURE__ */ F(y, {
			height: 24,
			width: 100 + e % 3 * 30,
			radius: "xl",
			animate: !0
		}),
		/* @__PURE__ */ F(y, {
			height: 20,
			width: 20,
			radius: "xl",
			animate: !0
		}),
		/* @__PURE__ */ F(y, {
			height: 20,
			width: 20,
			radius: "xl",
			animate: !0
		}),
		/* @__PURE__ */ F(y, {
			height: 20,
			width: 20,
			radius: "xl",
			animate: !0
		})
	]
}), ye = (e, t, n) => e === "member" ? /* @__PURE__ */ F(he, { index: n }) : e === "referral" ? /* @__PURE__ */ F(ge, { index: n }) : e === "carePlan" || t.toLowerCase().includes("care plan") ? /* @__PURE__ */ F(ve, { index: n }) : e === "engagementStatus" || e === "engagement" || t.toLowerCase().includes("engagement") ? /* @__PURE__ */ F(pe, { index: n }) : e === "name" || t.toLowerCase().includes("name") ? /* @__PURE__ */ F(me, { index: n }) : e.includes("Date") || e.includes("Encounter") || t.toLowerCase().includes("date") ? /* @__PURE__ */ F(fe, { index: n }) : e === "assignedClinician" || e === "pcp" || e === "assignedStaff" ? /* @__PURE__ */ F(_e, { index: n }) : t.toLowerCase().includes("status") ? /* @__PURE__ */ F(pe, { index: n }) : /* @__PURE__ */ F(de, { index: n }), be = ({ title: e, data: n, columns: r, actions: i, onRowClick: o, headerAction: s, additionalHeaderContent: c, pagination: l, loading: d = !1, skeletonRows: m = 5, tableLayout: _ = "auto", searchable: b = !1, filterable: C = !1, searchValue: w = "", onSearchChange: T, sortConfig: D, onSortChange: O, filters: k = {}, onFiltersChange: A, searchPlaceholder: te = "Search...", searchDebounceMs: P = 300, emptyContent: R }) => {
	let [, re] = N(null), [B, ie] = N(!1), [H, U] = N(!!w), [W, oe] = N(w), K = ne(void 0), ce = j((e) => {
		K.current && clearTimeout(K.current), K.current = setTimeout(() => {
			T?.(e);
		}, P);
	}, [T, P]);
	M(() => {
		ee(() => {
			oe(w), U(!!w);
		});
	}, [w]), M(() => () => {
		K.current && clearTimeout(K.current);
	}, []);
	let le = (e, t, n) => {
		let r = e.key.includes(".") ? e.key.split(".").reduce((e, t) => e?.[t], t) : t[e.key];
		return e.render ? e.render(r, t, n) : r == null ? "" : typeof r == "string" || typeof r == "number" ? r : String(r);
	}, J = (e) => {
		o && o(e);
	}, de = (e) => {
		if (!O) return;
		let t = e === "lastUpdated" ? "desc" : "asc";
		D?.key === e ? D.direction === t ? O({
			key: e,
			direction: t === "asc" ? "desc" : "asc"
		}) : O(null) : O({
			key: e,
			direction: t
		});
	}, fe = (e, t) => {
		if (!A) return;
		let n = { ...k };
		t ? n[e] = t : delete n[e], A(n);
	}, pe = () => {
		A && A({});
	}, me = () => {
		U(!0);
	}, he = () => {
		W || U(!1);
	}, ge = () => {
		oe(""), U(!1), K.current && clearTimeout(K.current), T?.("");
	}, _e = (e) => {
		oe(e), ce(e);
	}, ve = Object.keys(k).length > 0, be = r.filter((e) => e.filterable), xe = C && be.length > 0, Se = r.filter((e) => {
		if (e.render) try {
			return e.render(null, {}, 0) !== null;
		} catch {
			return !0;
		}
		return !0;
	}), Y = (e, t) => ye(e.key, e.label, t), Ce = () => Array.from({ length: m }, (e, t) => /* @__PURE__ */ I(x.Tr, {
		className: q.tableRow,
		children: [Se.map((e) => /* @__PURE__ */ F(x.Td, {
			className: q.tableCell,
			style: {
				paddingTop: "16px",
				paddingBottom: "16px"
			},
			children: Y(e, t)
		}, `skeleton-${t}-${e.key}`)), i && i.length > 0 && /* @__PURE__ */ F(x.Td, {
			className: q.actionsCell,
			style: {
				paddingTop: "16px",
				paddingBottom: "16px"
			},
			children: /* @__PURE__ */ F(y, {
				height: 24,
				width: 24,
				radius: "sm"
			})
		})]
	}, `skeleton-${t}`)), we = (e) => D?.key === e ? D.direction === "asc" ? /* @__PURE__ */ F(V, { size: 12 }) : /* @__PURE__ */ F(z, { size: 12 }) : /* @__PURE__ */ F(z, {
		size: 12,
		className: q.sortIcon
	});
	return /* @__PURE__ */ I(g, {
		className: q.container,
		children: [
			/* @__PURE__ */ F("div", {
				className: q.actionsHeader,
				children: /* @__PURE__ */ I(f, {
					justify: "space-between",
					align: "center",
					children: [/* @__PURE__ */ I(f, {
						gap: "md",
						children: [/* @__PURE__ */ I(f, {
							gap: "xs",
							children: [xe && /* @__PURE__ */ F(t, {
								variant: B ? "filled" : "subtle",
								color: B ? "purple" : "gray",
								size: "lg",
								onClick: () => ie(!B),
								className: q.filterIcon,
								children: /* @__PURE__ */ F(L, { size: 16 })
							}), b && /* @__PURE__ */ F("div", {
								className: q.searchContainer,
								children: H ? /* @__PURE__ */ F(ue, {
									placeholder: te,
									leftSection: /* @__PURE__ */ F(se, { size: 16 }),
									value: W,
									onChange: (e) => _e(e.currentTarget.value),
									onBlur: he,
									autoFocus: !0,
									variant: "filled",
									size: "sm",
									className: q.expandedSearch,
									"aria-label": `Search ${e.toLowerCase()}`,
									role: "searchbox",
									rightSection: W ? /* @__PURE__ */ F(t, {
										size: "sm",
										variant: "subtle",
										onClick: ge,
										"aria-label": "Clear search",
										children: /* @__PURE__ */ F(G, { size: 14 })
									}) : null
								}) : /* @__PURE__ */ F(t, {
									variant: W || H ? "filled" : "subtle",
									color: W || H ? "purple" : "gray",
									size: "lg",
									onClick: me,
									className: q.searchIcon,
									"aria-label": `Search ${e.toLowerCase()}`,
									children: /* @__PURE__ */ F(se, { size: 16 })
								})
							})]
						}), ve && /* @__PURE__ */ I(f, {
							gap: "xs",
							className: q.filtersIndicator,
							children: [/* @__PURE__ */ I(S, {
								size: "xs",
								c: "dimmed",
								children: [
									Object.keys(k).length,
									" filter",
									Object.keys(k).length === 1 ? "" : "s",
									" active"
								]
							}), /* @__PURE__ */ F(a, {
								variant: "subtle",
								size: "xs",
								onClick: pe,
								c: "dimmed",
								children: "Clear all"
							})]
						})]
					}), (s || c) && /* @__PURE__ */ I(f, {
						gap: "sm",
						children: [c, s && /* @__PURE__ */ F(E, {
							label: s.tooltip,
							disabled: !s.tooltip || !s.disabled,
							children: /* @__PURE__ */ F(a, {
								leftSection: s.icon,
								variant: "light",
								color: "purple",
								onClick: s.onClick,
								className: q.addButton,
								size: "sm",
								"aria-label": s.label,
								disabled: s.disabled,
								children: s.label
							})
						})]
					})]
				})
			}),
			B && xe && /* @__PURE__ */ F("div", {
				className: q.filtersSection,
				children: /* @__PURE__ */ F(f, {
					gap: "md",
					align: "flex-end",
					children: be.map((e) => /* @__PURE__ */ F("div", {
						style: { minWidth: 200 },
						children: e.filterType === "select" && e.filterOptions ? /* @__PURE__ */ F(v, {
							label: e.label,
							placeholder: `Filter by ${e.label.toLowerCase()}`,
							data: e.filterOptions,
							value: k[e.key] || null,
							onChange: (t) => fe(e.key, t || ""),
							clearable: !0,
							size: "sm"
						}) : /* @__PURE__ */ F(ue, {
							label: e.label,
							placeholder: `Filter by ${e.label.toLowerCase()}`,
							value: k[e.key] || "",
							onChange: (t) => fe(e.key, t.currentTarget.value),
							size: "sm"
						})
					}, e.key))
				})
			}),
			/* @__PURE__ */ F("div", {
				style: { overflowX: "auto" },
				children: /* @__PURE__ */ I(x, {
					className: q.table,
					style: _ === "fixed" ? { tableLayout: "fixed" } : void 0,
					highlightOnHover: !0,
					"aria-label": `${e} table`,
					children: [/* @__PURE__ */ F(x.Thead, { children: /* @__PURE__ */ I(x.Tr, { children: [Se.map((e) => /* @__PURE__ */ F(x.Th, {
						style: {
							width: e.width,
							cursor: e.sortable ? "pointer" : "default"
						},
						className: q.tableHeader,
						onClick: () => e.sortable && de(e.key),
						children: /* @__PURE__ */ I(f, {
							gap: "xs",
							justify: "space-between",
							children: [/* @__PURE__ */ F(S, {
								size: "sm",
								fw: 600,
								c: "dimmed",
								children: e.label
							}), e.sortable && we(e.key)]
						})
					}, e.key)), i && i.length > 0 && /* @__PURE__ */ F(x.Th, { className: q.actionsHeaderCell })] }) }), /* @__PURE__ */ F(x.Tbody, { children: d ? Ce() : n.length === 0 ? /* @__PURE__ */ F(x.Tr, { children: /* @__PURE__ */ F(x.Td, {
						colSpan: Se.length + +!!i,
						children: R ?? /* @__PURE__ */ F(S, {
							ta: "center",
							c: "dimmed",
							py: "xl",
							children: "No data available"
						})
					}) }) : n.map((e, n) => /* @__PURE__ */ I(x.Tr, {
						className: q.tableRow,
						onMouseEnter: () => re(n),
						onMouseLeave: () => re(null),
						onClick: () => J(e),
						style: { cursor: o ? "pointer" : "default" },
						children: [Se.map((t) => /* @__PURE__ */ F(x.Td, {
							className: q.tableCell,
							style: {
								width: t.width,
								minWidth: t.width,
								overflow: _ === "fixed" ? "hidden" : "visible"
							},
							children: le(t, e, n)
						}, t.key)), i && i.length > 0 && /* @__PURE__ */ F(x.Td, {
							className: q.actionsCell,
							children: /* @__PURE__ */ I(p, {
								position: "bottom-end",
								withArrow: !0,
								shadow: "md",
								trigger: "click",
								children: [/* @__PURE__ */ F(p.Target, { children: /* @__PURE__ */ F(t, {
									variant: "subtle",
									color: "gray",
									size: "sm",
									className: q.actionButton,
									onClick: (e) => e.stopPropagation(),
									children: /* @__PURE__ */ F(ae, { size: 16 })
								}) }), /* @__PURE__ */ F(p.Dropdown, { children: i.map((t) => /* @__PURE__ */ F(p.Item, {
									leftSection: t.icon,
									...t.color && { color: t.color },
									onClick: (n) => {
										n.stopPropagation(), t.onClick(e);
									},
									children: t.label
								}, t.key)) })]
							})
						})]
					}, e.id || n)) })]
				})
			}),
			l && !d && /* @__PURE__ */ I(u, {
				justify: "space-between",
				align: "center",
				className: q.footer,
				children: [/* @__PURE__ */ I(f, {
					gap: "sm",
					align: "center",
					children: [/* @__PURE__ */ I(S, {
						size: "sm",
						c: "dimmed",
						children: [
							"Showing",
							" ",
							Math.min((l.page - 1) * l.pageSize + 1, l.total),
							"-",
							Math.min(l.page * l.pageSize, l.total),
							" ",
							"of ",
							l.total,
							" ",
							e.toLowerCase()
						]
					}), l.onPageSizeChange && /* @__PURE__ */ I(f, {
						gap: "xs",
						align: "center",
						children: [/* @__PURE__ */ F(S, {
							size: "sm",
							c: "dimmed",
							children: "Show:"
						}), /* @__PURE__ */ F(v, {
							value: l.pageSize.toString(),
							onChange: (e) => l.onPageSizeChange?.(parseInt(e || "25", 10)),
							data: l.pageSizeOptions || [
								"10",
								"25",
								"50",
								"100"
							],
							size: "xs",
							style: { width: 80 }
						})]
					})]
				}), /* @__PURE__ */ F(h, {
					value: l.page,
					onChange: l.onPageChange,
					total: Math.ceil(l.total / l.pageSize),
					size: "sm"
				})]
			}),
			l && d && /* @__PURE__ */ I(u, {
				justify: "space-between",
				align: "center",
				className: q.footer,
				children: [/* @__PURE__ */ F(y, {
					height: 16,
					width: 150
				}), /* @__PURE__ */ F(y, {
					height: 32,
					width: 200
				})]
			})
		]
	});
}, xe = ({ date: e }) => {
	if (!e) return /* @__PURE__ */ F(S, {
		c: "dimmed",
		children: "—"
	});
	let t = typeof e == "string" ? K(e) : e;
	return isNaN(t.getTime()) ? /* @__PURE__ */ F(S, {
		c: "dimmed",
		children: "Invalid date"
	}) : /* @__PURE__ */ F(S, {
		size: "sm",
		children: t.toLocaleDateString("en-US", {
			year: "numeric",
			month: "2-digit",
			day: "2-digit"
		})
	});
}, Se = ({ text: e, color: t = "purple" }) => /* @__PURE__ */ F(r, {
	variant: "light",
	color: t,
	size: "sm",
	role: "status",
	"aria-label": `Status: ${e}`,
	children: e
}), Y = {
	drawerContent: "_drawerContent_vob9a_3",
	drawerContentRight: "_drawerContentRight_vob9a_16",
	drawerContentLeft: "_drawerContentLeft_vob9a_21",
	drawerContentTop: "_drawerContentTop_vob9a_26",
	drawerContentBottom: "_drawerContentBottom_vob9a_31",
	drawerHeader: "_drawerHeader_vob9a_39",
	drawerBody: "_drawerBody_vob9a_45",
	headerSection: "_headerSection_vob9a_52",
	headerContent: "_headerContent_vob9a_61",
	headerIcon: "_headerIcon_vob9a_67",
	headerTitle: "_headerTitle_vob9a_79",
	bodyContent: "_bodyContent_vob9a_87",
	drawerContentDark: "_drawerContentDark_vob9a_102",
	headerSectionDark: "_headerSectionDark_vob9a_127",
	headerIconDark: "_headerIconDark_vob9a_132",
	headerTitleDark: "_headerTitleDark_vob9a_138",
	closeButtonDark: "_closeButtonDark_vob9a_142"
}, Ce = (e) => {
	switch (e) {
		case "left": return Y.drawerContentLeft;
		case "top": return Y.drawerContentTop;
		case "bottom": return Y.drawerContentBottom;
		default: return Y.drawerContentRight;
	}
}, we = ({ title: e, icon: n, children: r, opened: a, onClose: o, showCloseButton: s = !0, headerActions: c, position: u = "right", size: d = "md", padding: p = "md", headerProps: m = {}, bodyProps: h = {}, preventClose: g = !1, colorScheme: _ = "light", transitionProps: v, "aria-label": y, ...x }) => {
	let C = () => {
		g || o();
	}, w = typeof e == "string" || typeof e == "number", T = !!(e || n || c || s), E = _ === "dark";
	return /* @__PURE__ */ F(l, {
		opened: a,
		onClose: C,
		position: u,
		size: d,
		padding: 0,
		transitionProps: {
			duration: 300,
			exitDuration: 200,
			timingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
			...u === "right" ? { transition: "slide-left" } : {},
			...v
		},
		closeOnClickOutside: !g,
		closeOnEscape: !g,
		withCloseButton: !1,
		attributes: { content: { "aria-label": y ?? (w ? String(e) : void 0) } },
		classNames: {
			content: [
				Y.drawerContent,
				Ce(u),
				E && Y.drawerContentDark
			].filter(Boolean).join(" "),
			header: Y.drawerHeader,
			body: Y.drawerBody
		},
		...x,
		children: /* @__PURE__ */ I(b, {
			gap: 0,
			h: "100%",
			children: [T && /* @__PURE__ */ F(i, {
				p: "md",
				className: [Y.headerSection, E && Y.headerSectionDark].filter(Boolean).join(" "),
				...m,
				children: /* @__PURE__ */ I(f, {
					justify: "space-between",
					align: "center",
					wrap: "nowrap",
					children: [/* @__PURE__ */ I(f, {
						gap: "sm",
						wrap: "nowrap",
						className: Y.headerContent,
						children: [n && /* @__PURE__ */ F(i, {
							className: [Y.headerIcon, E && Y.headerIconDark].filter(Boolean).join(" "),
							children: n
						}), e && (w ? /* @__PURE__ */ F(S, {
							fw: 600,
							className: [Y.headerTitle, E && Y.headerTitleDark].filter(Boolean).join(" "),
							truncate: !0,
							children: e
						}) : /* @__PURE__ */ F(i, {
							className: [Y.headerTitle, E && Y.headerTitleDark].filter(Boolean).join(" "),
							children: e
						}))]
					}), /* @__PURE__ */ I(f, {
						gap: "xs",
						wrap: "nowrap",
						children: [c, s && /* @__PURE__ */ F(t, {
							variant: "subtle",
							color: E ? void 0 : "gray",
							size: "lg",
							radius: "md",
							onClick: C,
							"aria-label": "Close",
							className: E ? Y.closeButtonDark : void 0,
							children: /* @__PURE__ */ F(G, { size: 18 })
						})]
					})]
				})
			}), /* @__PURE__ */ F(i, {
				className: Y.bodyContent,
				p,
				...h,
				children: r
			})]
		})
	});
}, X = {
	container: "_container_g0ucy_1",
	actionsHeader: "_actionsHeader_g0ucy_8",
	table: "_table_g0ucy_14",
	tableHeader: "_tableHeader_g0ucy_18",
	toggleHeaderCell: "_toggleHeaderCell_g0ucy_29",
	tableRow: "_tableRow_g0ucy_36",
	tableCell: "_tableCell_g0ucy_49",
	toggleCell: "_toggleCell_g0ucy_55",
	chevron: "_chevron_g0ucy_62",
	detailRow: "_detailRow_g0ucy_70",
	detailContent: "_detailContent_g0ucy_74",
	footer: "_footer_g0ucy_79"
}, Te = ({ title: e, data: n, columns: r, renderExpanded: i, getRowId: s, isRowExpandable: c, headerAction: l, additionalHeaderContent: d, pagination: p, loading: m = !1, skeletonRows: _ = 5, emptyContent: v, defaultExpandedIds: b }) => {
	let [C, w] = N(() => new Set(b)), T = (e) => {
		w((t) => {
			let n = new Set(t);
			return n.has(e) ? n.delete(e) : n.add(e), n;
		});
	}, D = r.length + 1;
	return /* @__PURE__ */ I(g, {
		className: X.container,
		children: [
			(l || d) && /* @__PURE__ */ F("div", {
				className: X.actionsHeader,
				children: /* @__PURE__ */ I(f, {
					justify: "flex-end",
					align: "center",
					gap: "sm",
					children: [d, l && /* @__PURE__ */ F(E, {
						label: l.tooltip,
						disabled: !l.tooltip,
						children: /* @__PURE__ */ F(a, {
							leftSection: l.icon,
							variant: "light",
							color: "purple",
							size: "sm",
							onClick: l.onClick,
							disabled: l.disabled,
							"aria-label": l.label,
							children: l.label
						})
					})]
				})
			}),
			/* @__PURE__ */ I(x, {
				className: X.table,
				"aria-label": `${e} table`,
				children: [/* @__PURE__ */ F(x.Thead, { children: /* @__PURE__ */ I(x.Tr, { children: [/* @__PURE__ */ F(x.Th, {
					className: X.toggleHeaderCell,
					"aria-hidden": !0
				}), r.map((e) => /* @__PURE__ */ F(x.Th, {
					className: X.tableHeader,
					style: {
						width: e.width,
						textAlign: e.align
					},
					children: e.label
				}, e.key))] }) }), /* @__PURE__ */ F(x.Tbody, { children: m ? Array.from({ length: _ }, (e, t) => /* @__PURE__ */ I(x.Tr, {
					className: X.tableRow,
					children: [/* @__PURE__ */ F(x.Td, {
						className: X.toggleCell,
						children: /* @__PURE__ */ F(y, {
							height: 20,
							width: 20,
							radius: "sm"
						})
					}), r.map((e) => /* @__PURE__ */ F(x.Td, {
						className: X.tableCell,
						children: /* @__PURE__ */ F(y, {
							height: 16,
							width: "70%",
							radius: "sm"
						})
					}, `skeleton-${t}-${e.key}`))]
				}, `skeleton-${t}`)) : n.length === 0 ? /* @__PURE__ */ F(x.Tr, { children: /* @__PURE__ */ F(x.Td, {
					colSpan: D,
					children: v ?? /* @__PURE__ */ F(S, {
						ta: "center",
						c: "dimmed",
						py: "xl",
						children: "No data available"
					})
				}) }) : n.map((n, a) => {
					let l = s(n, a), u = c?.(n) ?? !0, d = u && C.has(l), f = () => u && T(l);
					return /* @__PURE__ */ I(O, { children: [/* @__PURE__ */ I(x.Tr, {
						className: X.tableRow,
						"data-expanded": d || void 0,
						onClick: f,
						style: { cursor: u ? "pointer" : "default" },
						children: [/* @__PURE__ */ F(x.Td, {
							className: X.toggleCell,
							children: u && /* @__PURE__ */ F(t, {
								variant: "subtle",
								color: "gray",
								size: "sm",
								"aria-label": d ? `Collapse ${e} row` : `Expand ${e} row`,
								"aria-expanded": d,
								onClick: (e) => {
									e.stopPropagation(), f();
								},
								children: /* @__PURE__ */ F(ie, {
									size: 16,
									className: X.chevron,
									"data-expanded": d || void 0
								})
							})
						}), r.map((e) => /* @__PURE__ */ F(x.Td, {
							className: X.tableCell,
							style: {
								width: e.width,
								textAlign: e.align
							},
							children: e.render(n)
						}, e.key))]
					}), /* @__PURE__ */ F(x.Tr, {
						className: X.detailRow,
						children: /* @__PURE__ */ F(x.Td, {
							colSpan: D,
							p: 0,
							children: /* @__PURE__ */ F(o, {
								in: d,
								children: /* @__PURE__ */ F("div", {
									className: X.detailContent,
									children: d && i(n)
								})
							})
						})
					})] }, l);
				}) })]
			}),
			p && !m && n.length > 0 && /* @__PURE__ */ I(u, {
				justify: "space-between",
				align: "center",
				className: X.footer,
				children: [/* @__PURE__ */ I(S, {
					size: "sm",
					c: "dimmed",
					children: [
						"Showing",
						" ",
						Math.min((p.page - 1) * p.pageSize + 1, p.total),
						"-",
						Math.min(p.page * p.pageSize, p.total),
						" ",
						"of ",
						p.total,
						" ",
						e.toLowerCase()
					]
				}), /* @__PURE__ */ F(h, {
					value: p.page,
					onChange: p.onPageChange,
					total: Math.ceil(p.total / p.pageSize),
					size: "sm"
				})]
			})
		]
	});
}, Ee = ({ label: e, value: t, icon: n, iconColor: r = "var(--mantine-color-purple-6)", showDashWhenEmpty: a = !0, containerProps: o }) => {
	let s = t || (a ? "—" : null);
	return /* @__PURE__ */ I(i, {
		...o,
		children: [/* @__PURE__ */ I(f, {
			gap: "sm",
			mb: "sm",
			children: [n && /* @__PURE__ */ F("span", {
				style: { color: r },
				children: n
			}), /* @__PURE__ */ F(S, {
				fw: 600,
				size: "sm",
				c: "gray.7",
				children: e
			})]
		}), /* @__PURE__ */ F(S, {
			size: "sm",
			children: s
		})]
	});
}, De = ({ title: e, children: t, paperProps: n, useGrid: r = !1, gridSpan: i = 6 }) => /* @__PURE__ */ I(g, {
	shadow: "xs",
	p: "md",
	radius: "md",
	...n,
	children: [/* @__PURE__ */ F(S, {
		size: "sm",
		fw: 600,
		tt: "uppercase",
		c: "dimmed",
		mb: "lg",
		children: e
	}), r ? /* @__PURE__ */ F(d, { children: D.toArray(t).filter((e) => e == null || typeof e == "boolean" || typeof e == "string" && e.trim() === "" ? !1 : A(e)).map((e, t) => /* @__PURE__ */ F(d.Col, {
		span: i,
		children: e
	}, t)) }) : t]
}), Oe = {
	header: "_header_1xsab_1",
	title: "_title_1xsab_6",
	layout: "_layout_1xsab_12"
}, ke = ({ title: e, subtitle: t, icon: r, avatarColor: i = "purple", statusBadge: o, children: s, onEdit: c, onBack: l, editButtonText: u = "Edit", backButtonText: d = "Back", headerActions: p }) => /* @__PURE__ */ I(b, {
	gap: "lg",
	className: Oe.layout,
	children: [
		/* @__PURE__ */ I(f, {
			justify: "space-between",
			align: "center",
			wrap: "nowrap",
			className: Oe.header,
			children: [/* @__PURE__ */ I(f, {
				align: "center",
				gap: "md",
				style: {
					minWidth: 0,
					flex: 1
				},
				children: [r && /* @__PURE__ */ F(n, {
					size: "lg",
					radius: "md",
					color: i,
					children: r
				}), /* @__PURE__ */ I("div", {
					style: {
						minWidth: 0,
						flex: 1
					},
					children: [/* @__PURE__ */ F(T, {
						order: 1,
						size: "h2",
						mb: t ? 4 : "xs",
						className: Oe.title,
						children: e
					}), t && /* @__PURE__ */ F(S, {
						size: "sm",
						c: "dimmed",
						children: t
					})]
				})]
			}), /* @__PURE__ */ I(f, {
				gap: "sm",
				children: [o, p]
			})]
		}),
		s,
		(c || l) && /* @__PURE__ */ I(b, {
			gap: "sm",
			children: [c && /* @__PURE__ */ F(a, {
				leftSection: /* @__PURE__ */ F(U, { size: 16 }),
				onClick: c,
				size: "md",
				fullWidth: !0,
				children: u
			}), l && /* @__PURE__ */ F(a, {
				variant: "subtle",
				leftSection: /* @__PURE__ */ F(R, { size: 16 }),
				onClick: l,
				size: "md",
				fullWidth: !0,
				children: d
			})]
		})
	]
}), Ae = {
	true: "Active",
	false: "Inactive"
}, je = {
	true: "green",
	false: "red"
}, Me = {
	active: "green",
	inactive: "red",
	cancelled: "red",
	"entered-in-error": "red",
	draft: "yellow",
	planned: "blue",
	"in-progress": "blue",
	completed: "green",
	suspended: "orange",
	unknown: "gray"
}, Ne = ({ status: e, statusTextMap: t, statusColorMap: n, size: i = "xl", variant: a = "light" }) => {
	if (e == null) return /* @__PURE__ */ F(r, {
		color: "gray",
		size: i,
		variant: a,
		children: "Unknown"
	});
	if (typeof e == "boolean") {
		let o = t || Ae, s = n || je, c = e.toString();
		return /* @__PURE__ */ F(r, {
			color: s[c] || "gray",
			size: i,
			variant: a,
			children: o[c] || c
		});
	}
	let o = e.toString().toLowerCase(), s = n || Me, c = t?.[o] || e.toString();
	return /* @__PURE__ */ F(r, {
		color: s[o] || "gray",
		size: i,
		variant: a,
		children: c
	});
}, Z = {
	container: "_container_d95tu_2",
	grid: "_grid_d95tu_9",
	card: "_card_d95tu_16",
	selected: "_selected_d95tu_33",
	disabled: "_disabled_d95tu_39",
	indicator: "_indicator_d95tu_60",
	checkbox: "_checkbox_d95tu_61",
	icon: "_icon_d95tu_66",
	title: "_title_d95tu_71",
	subtitle: "_subtitle_d95tu_75",
	cardContent: "_cardContent_d95tu_80",
	indicatorDot: "_indicatorDot_d95tu_106",
	checkIcon: "_checkIcon_d95tu_138",
	textContent: "_textContent_d95tu_170",
	compact: "_compact_d95tu_202",
	error: "_error_d95tu_224"
}, Pe = k(function({ data: e, value: t, onChange: n, multiple: r = !1, placeholder: i, disabled: a = !1, error: o = !1, compact: s = !1, showIndicators: c = !0, columns: l = 1, renderCard: u, "aria-label": d, "data-testid": f }, p) {
	let m = te(() => e.map((e) => "description" in e || "icon" in e || "disabled" in e ? e : {
		value: e.value,
		label: e.label
	}), [e]), h = te(() => t ? Array.isArray(t) ? t : [t] : [], [t]), g = j((e) => h.includes(e), [h]), _ = j((e) => {
		if (!a) {
			if (r) {
				let t;
				t = g(e) ? h.filter((t) => t !== e) : [...h, e], n?.(t.length > 0 ? t : null);
			} else {
				let t = g(e) ? null : e;
				n?.(t);
			}
		}
	}, [
		a,
		r,
		g,
		h,
		n
	]), v = j((e, t) => {
		let n = a || e.disabled, i = [
			Z.card,
			t && Z.selected,
			n && Z.disabled,
			o && Z.error,
			s && Z.compact
		].filter(Boolean).join(" "), l = /* @__PURE__ */ F("div", {
			className: i,
			onClick: () => !n && _(e.value),
			onKeyDown: (t) => {
				t.key !== "Enter" && t.key !== " " || n || (t.preventDefault(), _(e.value));
			},
			tabIndex: n ? -1 : 0,
			role: r ? "checkbox" : "radio",
			"aria-checked": t,
			"aria-disabled": n,
			children: /* @__PURE__ */ I("div", {
				className: Z.cardContent,
				children: [
					c && /* @__PURE__ */ F("div", {
						className: r ? Z.checkbox : Z.indicator,
						children: r ? /* @__PURE__ */ F(re, { className: Z.checkIcon }) : /* @__PURE__ */ F("div", { className: Z.indicatorDot })
					}),
					e.icon && /* @__PURE__ */ F("div", {
						className: Z.icon,
						children: e.icon
					}),
					/* @__PURE__ */ I("div", {
						className: Z.textContent,
						children: [/* @__PURE__ */ F("div", {
							className: Z.title,
							children: e.label
						}), e.description && /* @__PURE__ */ F("div", {
							className: Z.subtitle,
							children: e.description
						})]
					})
				]
			})
		}, e.value);
		return e.disabled && e.disabledTooltip ? /* @__PURE__ */ F(E, {
			label: e.disabledTooltip,
			withArrow: !0,
			children: /* @__PURE__ */ F("div", { children: l })
		}, e.value) : l;
	}, [
		a,
		r,
		c,
		s,
		o,
		_
	]), y = [
		Z.container,
		l > 1 && Z.grid,
		a && Z.disabled
	].filter(Boolean).join(" ");
	return /* @__PURE__ */ F("div", {
		ref: p,
		className: y,
		style: l > 1 ? { "--columns": l } : void 0,
		role: r ? "group" : "radiogroup",
		"aria-label": d || i || "Select an option",
		"aria-disabled": a || void 0,
		"data-testid": f,
		children: m.map((e) => {
			let t = g(e.value);
			return u ? u(e, t) : v(e, t);
		})
	});
}), Fe = ({ isSubmitting: e, resourceType: t, isEditing: n, showCancel: r = !0, onCancel: i, submitText: o, submitButtonProps: s = {} }) => {
	let c = ce(), l = () => {
		i ? i() : c(-1);
	}, u = () => o || (e ? `${n ? "Updating" : "Creating"} ${t}...` : `${n ? "Update" : "Create"} ${t}`);
	return /* @__PURE__ */ I(f, {
		justify: "flex-end",
		mt: "md",
		children: [r && /* @__PURE__ */ F(a, {
			variant: "outline",
			onClick: l,
			disabled: e,
			size: "lg",
			children: "Cancel"
		}), /* @__PURE__ */ F(a, {
			type: "submit",
			loading: e,
			disabled: e,
			size: "lg",
			style: { minWidth: "200px" },
			...s,
			children: u()
		})]
	});
}, Ie = ({ isSubmitting: e, resourceText: n, isEditing: r, showCancel: o = !0, onCancel: s, submitText: c, submitButtonProps: l = {}, showSaveDraft: u = !1, onSaveDraft: d, isDraftSaving: m = !1, showReset: h = !1, onReset: g, showProgress: v = !1, progress: y = 0, progressLabel: b, customActions: x, layout: C = "horizontal", buttonSize: w = "lg", hasUnsavedChanges: T = !1, autoSaveStatus: E = "idle", lastSaved: D }) => {
	let O = ce(), k = () => {
		s ? s() : O(-1);
	}, A = () => {
		g && g();
	}, ee = () => {
		d && d();
	}, j = () => c || (e ? `${r ? "Updating" : "Creating"} ${n}...` : `${r ? "Update" : "Create"} ${n}`), M = (() => {
		switch (E) {
			case "saving": return "Saving draft...";
			case "saved": return D ? `Draft saved at ${D.toLocaleTimeString()}` : "Draft saved";
			case "error": return "Error saving draft";
			default: return T ? "You have unsaved changes" : "";
		}
	})();
	return /* @__PURE__ */ I(i, { children: [
		v && /* @__PURE__ */ I(i, {
			mb: "md",
			children: [/* @__PURE__ */ F(_, {
				value: y,
				size: "sm"
			}), b && /* @__PURE__ */ F(S, {
				size: "xs",
				c: "dimmed",
				mt: 4,
				children: b
			})]
		}),
		M && /* @__PURE__ */ F(S, {
			size: "xs",
			c: "dimmed",
			mb: "sm",
			ta: "right",
			children: M
		}),
		/* @__PURE__ */ I(f, {
			justify: C === "horizontal" ? "flex-end" : "center",
			mt: "md",
			style: {
				flexDirection: C === "vertical" ? "column" : "row",
				width: C === "vertical" ? "100%" : "auto"
			},
			children: [
				(h || u) && /* @__PURE__ */ I(p, {
					shadow: "md",
					width: 200,
					children: [/* @__PURE__ */ F(p.Target, { children: /* @__PURE__ */ F(t, {
						variant: "outline",
						size: w,
						disabled: e,
						children: /* @__PURE__ */ F(z, { size: 16 })
					}) }), /* @__PURE__ */ I(p.Dropdown, { children: [u && /* @__PURE__ */ F(p.Item, {
						leftSection: /* @__PURE__ */ F(H, { size: 14 }),
						onClick: ee,
						disabled: m || e,
						children: m ? "Saving Draft..." : "Save Draft"
					}), h && /* @__PURE__ */ F(p.Item, {
						leftSection: /* @__PURE__ */ F(oe, { size: 14 }),
						onClick: A,
						disabled: e,
						color: "orange",
						children: "Reset Form"
					})] })]
				}),
				x,
				o && /* @__PURE__ */ F(a, {
					variant: "outline",
					onClick: k,
					disabled: e,
					size: w,
					leftSection: /* @__PURE__ */ F(G, { size: 16 }),
					style: { width: C === "vertical" ? "100%" : "auto" },
					children: "Cancel"
				}),
				u && !h && /* @__PURE__ */ F(a, {
					variant: "light",
					onClick: ee,
					disabled: m || e,
					size: w,
					leftSection: /* @__PURE__ */ F(H, { size: 16 }),
					style: { width: C === "vertical" ? "100%" : "auto" },
					children: m ? "Saving..." : "Save Draft"
				}),
				/* @__PURE__ */ F(a, {
					type: "submit",
					loading: e,
					disabled: e,
					size: w,
					style: {
						minWidth: C === "horizontal" ? "200px" : "100%",
						width: C === "vertical" ? "100%" : "auto"
					},
					...l,
					children: j()
				})
			]
		})
	] });
}, Le = {
	root: "_root_13rpa_8",
	label: "_label_13rpa_13",
	input: "_input_13rpa_40"
}, Re = ({ label: e, value: t, onChange: n, placeholder: r, disabled: i, error: a, maxLength: o, ...s }) => {
	let [c, l] = N(!1), u = c || (t?.length ?? 0) > 0;
	return /* @__PURE__ */ F(C, {
		label: e,
		placeholder: u ? r : void 0,
		classNames: Le,
		value: t || "",
		onChange: (e) => n(e.currentTarget.value),
		onFocus: () => l(!0),
		onBlur: () => l(!1),
		"data-floating": u,
		disabled: i,
		error: a,
		maxLength: o,
		labelProps: { "data-floating": u },
		...s
	});
}, ze = {
	root: "_root_1s3go_8",
	label: "_label_1s3go_12",
	input: "_input_1s3go_38"
}, Be = ({ label: e, value: t, onChange: n, placeholder: r, disabled: i, error: a, ...o }) => {
	let [s, c] = N(!1), l = s || (t?.length ?? 0) > 0;
	return /* @__PURE__ */ F(w, {
		label: e,
		placeholder: l ? r : void 0,
		classNames: ze,
		value: t || "",
		onChange: (e) => n(e.currentTarget.value),
		onFocus: () => c(!0),
		onBlur: () => c(!1),
		"data-floating": l,
		disabled: i,
		error: a,
		autosize: !0,
		minRows: 1,
		labelProps: { "data-floating": l },
		...o
	});
}, Ve = ({ label: e, description: t, error: n, required: r = !1, tooltip: a, children: o, variant: s = "default", showDivider: l = !0, readOnly: u = !1, fieldProps: d = {}, labelProps: f = {} }) => {
	let p = s === "section" ? { ...d } : {
		mt: "xs",
		...d
	};
	return /* @__PURE__ */ I(i, {
		...p,
		children: [
			e && s === "section" ? /* @__PURE__ */ I(i, {
				mb: 8,
				children: [/* @__PURE__ */ I(T, {
					order: 3,
					size: "md",
					mb: t ? 4 : 0,
					style: {
						color: "var(--mantine-color-gray-7)",
						display: "flex",
						alignItems: "center",
						textTransform: typeof e == "string" ? "uppercase" : "none",
						gap: "4px"
					},
					children: [
						e,
						r && /* @__PURE__ */ F(S, {
							component: "span",
							c: "red",
							ml: 2,
							children: "*"
						}),
						a && /* @__PURE__ */ F(E, {
							label: a,
							position: "top-start",
							withArrow: !0,
							children: /* @__PURE__ */ F(W, {
								size: 16,
								style: {
									color: "var(--mantine-color-gray-6)",
									marginLeft: "4px"
								}
							})
						})
					]
				}), t && /* @__PURE__ */ F(S, {
					size: "sm",
					c: "dimmed",
					children: t
				})]
			}) : e ? /* @__PURE__ */ F(i, {
				mb: "xs",
				style: {
					display: "flex",
					alignItems: "center",
					gap: "4px"
				},
				children: typeof e == "string" ? /* @__PURE__ */ I(P, { children: [/* @__PURE__ */ I(S, {
					component: "label",
					size: "sm",
					fw: 500,
					...f,
					children: [e, r && /* @__PURE__ */ F(S, {
						component: "span",
						c: "red",
						ml: 2,
						children: "*"
					})]
				}), a && /* @__PURE__ */ F(E, {
					label: a,
					position: "top-start",
					withArrow: !0,
					children: /* @__PURE__ */ F(W, {
						size: 16,
						style: { color: "var(--mantine-color-gray-6)" }
					})
				})] }) : /* @__PURE__ */ I(P, { children: [
					e,
					r && /* @__PURE__ */ F(S, {
						component: "span",
						c: "red",
						ml: 2,
						children: "*"
					}),
					a && /* @__PURE__ */ F(E, {
						label: a,
						position: "top-start",
						withArrow: !0,
						children: /* @__PURE__ */ F(W, {
							size: 16,
							style: { color: "var(--mantine-color-gray-6)" }
						})
					})
				] })
			}) : null,
			t && s === "default" && /* @__PURE__ */ F(S, {
				size: "xs",
				c: "dimmed",
				mb: "xs",
				children: t
			}),
			/* @__PURE__ */ F(i, {
				mb: s === "section" ? "sm" : void 0,
				style: u ? {
					opacity: .6,
					pointerEvents: "none",
					filter: "grayscale(0.3)"
				} : void 0,
				children: o
			}),
			s === "section" && l && /* @__PURE__ */ F(c, { mb: "md" }),
			n && /* @__PURE__ */ F(S, {
				size: "xs",
				c: "red",
				mt: "xs",
				children: n
			})
		]
	});
}, He = (e) => /* @__PURE__ */ F(Ve, {
	...e,
	required: !0
}), Ue = ({ label: e, ...t }) => {
	let n = e ? typeof e == "string" ? `${e} (optional)` : /* @__PURE__ */ I(P, { children: [
		e,
		" ",
		/* @__PURE__ */ F(S, {
			component: "span",
			c: "dimmed",
			children: "(optional)"
		})
	] }) : void 0;
	return /* @__PURE__ */ F(Ve, {
		...t,
		label: n,
		required: !1
	});
}, We = ({ children: e, grow: t = !0, gap: n = "md", align: r = "flex-start", wrap: i = "wrap", ...a }) => /* @__PURE__ */ F(f, {
	grow: t,
	gap: n,
	align: r,
	wrap: i,
	...a,
	children: e
}), Ge = ({ title: e, children: t, subtitle: n, showDivider: r = !0, collapsible: a = !1, defaultCollapsed: o = !1, sectionProps: s = {} }) => {
	let [l, u] = N(o), d = () => {
		a && u(!l);
	};
	return /* @__PURE__ */ F(i, {
		...s,
		children: /* @__PURE__ */ I(b, {
			gap: 8,
			children: [
				/* @__PURE__ */ I(i, { children: [/* @__PURE__ */ I(T, {
					order: 3,
					size: "md",
					mb: n ? 4 : 0,
					style: {
						color: "var(--mantine-color-gray-7)",
						cursor: a ? "pointer" : "default",
						display: "flex",
						alignItems: "center",
						textTransform: "uppercase",
						gap: "4px"
					},
					onClick: d,
					children: [e, a && /* @__PURE__ */ F(i, {
						style: {
							transform: l ? "rotate(-90deg)" : "rotate(0deg)",
							transition: "transform 0.2s ease",
							fontSize: "0.8em"
						},
						children: "▼"
					})]
				}), n && /* @__PURE__ */ F(S, {
					size: "sm",
					color: "dimmed",
					children: n
				})] }),
				(!a || !l) && /* @__PURE__ */ F(i, {
					mb: "sm",
					children: t
				}),
				r && (!a || !l) && /* @__PURE__ */ F(c, { mb: "md" })
			]
		})
	});
};
// src/components/atomic/forms/PhoneInput.tsx
function Ke(e) {
	let t = e.slice(0, 3), n = e.slice(3, 6), r = e.slice(6, 10);
	return e.length <= 3 ? t ? `(${t}` : "" : e.length <= 6 ? `(${t}) ${n}` : `(${t}) ${n}-${r}`;
}
function qe(e) {
	if (!e) return "";
	let t = e.replace(/\D/g, "");
	return t.length === 11 && t.startsWith("1") ? Ke(t.slice(1)) : t.length <= 10 ? Ke(t) : e;
}
var Je = k(({ value: e, onChange: t, onBlur: n, autoComplete: r, ...i }, a) => {
	let o = j((e) => {
		let n = Ke(e.currentTarget.value.replace(/\D/g, "").slice(0, 10)), r = {
			...e,
			target: Object.assign(e.target, { value: n }),
			currentTarget: Object.assign(e.currentTarget, { value: n }),
			bubbles: e.bubbles,
			cancelable: e.cancelable,
			defaultPrevented: e.defaultPrevented,
			eventPhase: e.eventPhase,
			isTrusted: e.isTrusted,
			nativeEvent: e.nativeEvent,
			preventDefault: e.preventDefault.bind(e),
			isDefaultPrevented: e.isDefaultPrevented.bind(e),
			stopPropagation: e.stopPropagation.bind(e),
			isPropagationStopped: e.isPropagationStopped.bind(e),
			persist: e.persist.bind(e),
			timeStamp: e.timeStamp,
			type: e.type
		};
		t?.(r);
	}, [t]), s = j((e) => {
		let r = le(e.currentTarget.value), i = {
			...e,
			target: Object.assign(e.target, { value: r }),
			currentTarget: Object.assign(e.currentTarget, { value: r })
		};
		t?.(i), n?.(e);
	}, [t, n]);
	return /* @__PURE__ */ F(C, {
		ref: a,
		type: "tel",
		value: qe(e),
		onChange: o,
		onBlur: s,
		autoComplete: r ?? "off",
		...i
	});
});
Je.displayName = "PhoneInput";
// src/components/atomic/forms/PractitionerRoleSearchSelect.tsx
var Ye = ({ options: e, value: t, searchQuery: n, isSearching: r, onSearchChange: i, onChange: a, placeholder: o, noResultsMessage: s, error: c, disabled: l = !1, minSearchLength: u = 2, clearable: d = !0 }) => {
	let f = n.trim().length >= u, p = f ? r ? "Searching..." : s : `Type at least ${u} characters to search`;
	return /* @__PURE__ */ F(v, {
		data: e,
		searchable: !0,
		clearable: d,
		onSearchChange: i,
		onChange: a,
		value: t,
		filter: ({ options: e }) => e,
		nothingFoundMessage: p,
		placeholder: f && r ? "Searching..." : o,
		error: c,
		disabled: l
	});
}, Xe = ({ value: e, onChange: t, disabled: n }) => /* @__PURE__ */ I(P, { children: [/* @__PURE__ */ F(Ve, {
	label: "Scratch Pad",
	variant: "section",
	showDivider: !1,
	children: /* @__PURE__ */ F(w, {
		value: e,
		onChange: (e) => t(e.currentTarget.value),
		autosize: !0,
		minRows: 2,
		disabled: n,
		placeholder: "Notes, observations, and important details from the conversation..."
	})
}), /* @__PURE__ */ F(c, { my: "md" })] });
// src/components/atomic/forms/SteppedForm.utils.ts
function Ze(e, t) {
	return t.split(".").reduce((e, t) => e && typeof e == "object" && t in e ? e[t] : void 0, e);
}
function Qe(e) {
	let t = e.split(".").pop() || e, n = t.replace(/([A-Z])/g, " $1").replace(/-/g, " ").replace(/\b\w/g, (e) => e.toUpperCase()).trim();
	return {
		carePlanType: {
			label: "Care plan type",
			isSelection: !0
		},
		consentDate: {
			label: "Consent date",
			isSelection: !1
		},
		periodStart: {
			label: "Start date",
			isSelection: !1
		},
		careTeamId: {
			label: "Care team",
			isSelection: !0
		},
		"patient-id": {
			label: "Member",
			isSelection: !0
		},
		"assigned-to": {
			label: "Owner",
			isSelection: !0
		},
		"due-date": {
			label: "Due date",
			isSelection: !1
		},
		"task-type": {
			label: "Task type",
			isSelection: !0
		},
		"encounter-type": {
			label: "Interaction type",
			isSelection: !0
		}
	}[t] || {
		label: n,
		isSelection: !1
	};
}
function $e(e, t) {
	if (e.validate) {
		let n = e.validate(t);
		if (n && Object.keys(n).length > 0) return !1;
	}
	return !(e.requiredFields && !e.requiredFields.every((e) => {
		let n = Ze(t, e);
		return n != null && n !== "";
	}) || e.isValid && !e.isValid(t));
}
var Q = {
	stepContent: "_stepContent_1n1j1_2",
	fadeIn: "_fadeIn_1n1j1_1",
	stepLabel: "_stepLabel_1n1j1_8",
	current: "_current_1n1j1_25",
	stepTitleWrapper: "_stepTitleWrapper_1n1j1_30",
	stepTitle: "_stepTitle_1n1j1_30",
	pending: "_pending_1n1j1_60",
	completed: "_completed_1n1j1_69",
	valid: "_valid_1n1j1_74",
	error: "_error_1n1j1_79",
	stepIcon: "_stepIcon_1n1j1_85",
	progress: "_progress_1n1j1_166",
	progressBar: "_progressBar_1n1j1_172",
	primaryButton: "_primaryButton_1n1j1_179",
	slideIn: "_slideIn_1n1j1_1"
}, et = ({ children: e }) => /* @__PURE__ */ F(P, { children: e }), tt = ({ form: t, steps: n, children: r, showProgress: o = !0, showNavigation: s = !0, onSubmit: l, isSubmitting: u = !1, submitText: d = "Submit", showCancel: p = !0, onCancel: m, allowFreeNavigation: h = !1, onSaveDraft: g, isDraftSaving: v = !1, lastStepFooter: y, initialStepIndex: x }) => {
	let C = typeof x == "number" && x >= 0 && x < n.length ? x : 0, [w, T] = N(C), [E, O] = N(() => /* @__PURE__ */ new Set([C])), k = ne(null);
	M(() => {
		let e = k.current;
		if (!e) return;
		let t = e.parentElement;
		for (; t;) {
			if (t.scrollHeight > t.clientHeight) {
				t.scrollTo({
					top: 0,
					behavior: "smooth"
				});
				return;
			}
			t = t.parentElement;
		}
	}, [w]);
	let A = te(() => n.filter((e) => !e.showWhen || e.showWhen(t.values)), [n, t.values]), P = A[w], L = w === A.length - 1, R = w === 0;
	M(() => {
		if (w >= A.length) {
			let e = Math.max(A.length - 1, 0);
			ee(() => {
				T(e), O((t) => /* @__PURE__ */ new Set([...t, e]));
			});
		}
	}, [A.length, w]);
	let z = j((e) => $e(e, t.values), [t.values]), V = j((e, t) => Ze(e, t), []), H = j(async (e) => {
		e !== w && (T(e), O((t) => /* @__PURE__ */ new Set([...t, e])));
	}, [w]), ae = j(async () => {
		if (L) return;
		let e = !0;
		if (P.validate) {
			let n = P.validate(t.values);
			n && Object.keys(n).length > 0 && (t.setErrors(n), e = !1);
		}
		if (P.requiredFields) {
			let n = {};
			P.requiredFields.forEach((e) => {
				let r = V(t.values, e);
				if (r == null || r === "") {
					let r = t.errors[e];
					if (r && typeof r == "string") n[e] = r;
					else {
						let { label: t, isSelection: r } = Qe(e);
						n[e] = r ? `Please select a ${t.toLowerCase()}` : `Please enter a ${t.toLowerCase()}`;
					}
				}
			}), Object.keys(n).length > 0 && (t.setErrors({
				...t.errors,
				...n
			}), e = !1);
		}
		P.isValid && !P.isValid(t.values) && t.validate().hasErrors && (e = !1), e && (t.clearErrors(), await H(w + 1));
	}, [
		w,
		P,
		L,
		t,
		H,
		V
	]), U = j(async () => {
		R || await H(w - 1);
	}, [
		w,
		R,
		H
	]), W = j(() => {
		m?.();
	}, [m]), oe = j(async () => {
		if (!l) return;
		let n = !0, r = {};
		if (A.forEach((e) => {
			if (e.validate) {
				let i = e.validate(t.values);
				i && Object.keys(i).length > 0 && (Object.assign(r, i), n = !1);
			}
			e.requiredFields && e.requiredFields.forEach((e) => {
				let i = V(t.values, e);
				if (i == null || i === "") {
					let i = t.errors[e];
					if (i && typeof i == "string") r[e] = i;
					else {
						let { label: t, isSelection: n } = Qe(e);
						r[e] = n ? `Please select a ${t.toLowerCase()}` : `Please enter a ${t.toLowerCase()}`;
					}
					n = !1;
				}
			}), e.isValid && !e.isValid(t.values) && (n = !1);
		}), !n) {
			let n = {
				...t.validate().errors,
				...r
			};
			t.setErrors(n), e("Missing required fields.", { autoClose: 5e3 });
			let i = 0;
			A.some((e, r) => {
				let a = !1;
				if (e.requiredFields && (a = e.requiredFields.some((e) => e in n)), !a && e.validate) {
					let n = e.validate(t.values);
					n && Object.keys(n).length > 0 && (a = !0);
				}
				return !a && e.isValid && !e.isValid(t.values) && (a = !0), a ? (i = r, !0) : !1;
			}), T(i), O((e) => /* @__PURE__ */ new Set([...e, i]));
		} else await l(t.values);
	}, [
		l,
		t,
		A,
		V
	]), se = j((e, t) => t < w ? "completed" : t === w ? "current" : E.has(t) && z(e) ? "valid" : E.has(t) ? "error" : "pending", [
		w,
		E,
		z
	]), G = (w + 1) / A.length * 100, K = te(() => D.toArray(r).find((e) => e.props.id === P?.id), [r, P]);
	return M(() => {
		P && z(P) && E.has(w + 1);
	}, [
		P,
		z,
		E,
		w
	]), P ? /* @__PURE__ */ I(b, {
		gap: "md",
		children: [
			/* @__PURE__ */ F("div", { ref: k }),
			o && /* @__PURE__ */ I(i, { children: [
				/* @__PURE__ */ I(f, {
					justify: "space-between",
					mb: "xs",
					children: [/* @__PURE__ */ I(f, { children: [/* @__PURE__ */ I(S, {
						size: "sm",
						fw: 600,
						children: [
							"Step ",
							w + 1,
							" of ",
							A.length
						]
					}), /* @__PURE__ */ F(S, {
						size: "sm",
						c: "dimmed",
						children: P.subtitle
					})] }), /* @__PURE__ */ I(S, {
						size: "sm",
						c: "dimmed",
						children: [Math.round(G), "% Complete"]
					})]
				}),
				/* @__PURE__ */ F(_, {
					value: G,
					size: "sm",
					mb: "md"
				}),
				/* @__PURE__ */ F(f, {
					gap: 4,
					wrap: "wrap",
					children: A.map((e, t) => {
						let n = se(e, t), r = h || t <= w || E.has(t);
						return /* @__PURE__ */ F(i, {
							className: `${Q.stepLabel} ${Q[n]}`,
							onClick: r ? () => H(t) : void 0,
							style: { cursor: r ? "pointer" : "default" },
							children: /* @__PURE__ */ I(f, {
								gap: 0,
								align: "center",
								wrap: "nowrap",
								children: [/* @__PURE__ */ F(i, {
									className: Q.stepIcon,
									children: n === "completed" ? /* @__PURE__ */ F(re, {
										size: 16,
										stroke: 2.5,
										color: "var(--brand-fill)"
									}) : /* @__PURE__ */ F(S, {
										size: "xs",
										fw: 600,
										children: t + 1
									})
								}), /* @__PURE__ */ F("div", {
									className: Q.stepTitleWrapper,
									children: /* @__PURE__ */ F(S, {
										size: "xs",
										fw: n === "current" ? 600 : 400,
										className: Q.stepTitle,
										children: e.title
									})
								})]
							})
						}, e.id);
					})
				})
			] }),
			/* @__PURE__ */ F(c, {}),
			/* @__PURE__ */ I(i, {
				className: Q.stepContent,
				role: "group",
				"aria-roledescription": "form step",
				"aria-label": P?.title,
				children: [K, L && y ? y : null]
			}),
			s && /* @__PURE__ */ I(f, {
				justify: "space-between",
				children: [/* @__PURE__ */ I(f, { children: [p && /* @__PURE__ */ F(a, {
					variant: "subtle",
					onClick: W,
					disabled: u || v,
					children: "Cancel"
				}), g && /* @__PURE__ */ F(a, {
					variant: "outline",
					color: "purple",
					onClick: g,
					loading: v,
					disabled: u || v,
					children: v ? "Saving Draft..." : "Save Draft"
				})] }), /* @__PURE__ */ I(f, { children: [/* @__PURE__ */ F(a, {
					variant: "outline",
					leftSection: /* @__PURE__ */ F(B, { size: 16 }),
					onClick: U,
					disabled: R || u,
					children: "Previous"
				}), L ? /* @__PURE__ */ F(a, {
					type: "submit",
					loading: u,
					onClick: oe,
					disabled: u,
					className: Q.primaryButton,
					children: d
				}) : /* @__PURE__ */ F(a, {
					rightSection: /* @__PURE__ */ F(ie, { size: 16 }),
					onClick: ae,
					disabled: u,
					className: Q.primaryButton,
					children: "Next"
				})] })]
			})
		]
	}) : /* @__PURE__ */ F("div", { children: "No valid steps found" });
}, nt = {
	light: "brightness(0) invert(1)",
	dark: "brightness(0) saturate(100%) invert(0) sepia(0) saturate(0) hue-rotate(0deg) brightness(0) contrast(100%)",
	brand: "brightness(0) saturate(100%) invert(20%) sepia(100%) saturate(1000%) hue-rotate(250deg) brightness(90%) contrast(90%)"
}, rt = {
	standard: "/benchmark-health-wordmark.svg",
	extended: "/benchmark-health-wordmark_extended.svg",
	favicon: "/benchmark-health-favicon.svg"
}, it = ({ size: e = 120, color: t = "brand", variant: n = "standard" }) => /* @__PURE__ */ F("img", {
	src: rt[n],
	alt: "Benchmark Health Logo",
	style: {
		width: e,
		height: "auto",
		filter: nt[t]
	}
}), at = ({ sections: e = 3, fieldsPerSection: t = 4 }) => /* @__PURE__ */ F(s, {
	size: "md",
	py: "md",
	children: /* @__PURE__ */ I(b, {
		gap: "lg",
		children: [/* @__PURE__ */ F(y, {
			height: 32,
			width: 250
		}), Array.from({ length: e }, (e, n) => /* @__PURE__ */ I(g, {
			p: "md",
			withBorder: !0,
			children: [/* @__PURE__ */ F(y, {
				height: 20,
				width: 150,
				mb: "md"
			}), /* @__PURE__ */ F(b, {
				gap: "sm",
				children: Array.from({ length: t }, (e, t) => /* @__PURE__ */ F(y, {
					height: 16,
					width: `${60 + t * 10}%`
				}, t))
			})]
		}, n))]
	})
}), ot = () => /* @__PURE__ */ F(s, {
	size: "md",
	py: "md",
	children: /* @__PURE__ */ I(b, {
		gap: "md",
		children: [/* @__PURE__ */ I(f, {
			justify: "space-between",
			children: [/* @__PURE__ */ I(f, { children: [/* @__PURE__ */ F(y, {
				height: 24,
				width: 24,
				radius: "sm"
			}), /* @__PURE__ */ F(y, {
				height: 28,
				width: 200
			})] }), /* @__PURE__ */ I(f, { children: [/* @__PURE__ */ F(y, {
				height: 36,
				width: 80,
				radius: "sm"
			}), /* @__PURE__ */ F(y, {
				height: 36,
				width: 100,
				radius: "sm"
			})] })]
		}), /* @__PURE__ */ F(b, {
			gap: "lg",
			children: Array.from({ length: 3 }, (e, t) => /* @__PURE__ */ I(g, {
				p: "md",
				withBorder: !0,
				children: [/* @__PURE__ */ F(y, {
					height: 20,
					width: 150,
					mb: "md"
				}), /* @__PURE__ */ F(b, {
					gap: "sm",
					children: Array.from({ length: 4 }, (e, t) => /* @__PURE__ */ I(f, {
						justify: "space-between",
						children: [/* @__PURE__ */ F(y, {
							height: 14,
							width: 100
						}), /* @__PURE__ */ F(y, {
							height: 14,
							width: 200
						})]
					}, t))
				})]
			}, t))
		})]
	})
}), st = () => /* @__PURE__ */ F(s, {
	size: "xl",
	py: "md",
	children: /* @__PURE__ */ I(b, {
		gap: "md",
		children: [
			/* @__PURE__ */ I(f, {
				justify: "space-between",
				align: "center",
				children: [/* @__PURE__ */ I(f, { children: [/* @__PURE__ */ F(y, {
					height: 24,
					width: 24,
					radius: "sm"
				}), /* @__PURE__ */ F(y, {
					height: 32,
					width: 200
				})] }), /* @__PURE__ */ F(y, {
					height: 36,
					width: 120,
					radius: "sm"
				})]
			}),
			/* @__PURE__ */ I(f, {
				mb: "md",
				align: "center",
				justify: "space-between",
				wrap: "wrap",
				w: "100%",
				children: [/* @__PURE__ */ I(f, {
					gap: "xs",
					children: [
						/* @__PURE__ */ F(y, {
							height: 32,
							width: 60,
							radius: "sm"
						}),
						/* @__PURE__ */ F(y, {
							height: 32,
							width: 80,
							radius: "sm"
						}),
						/* @__PURE__ */ F(y, {
							height: 32,
							width: 70,
							radius: "sm"
						}),
						/* @__PURE__ */ F(y, {
							height: 32,
							width: 90,
							radius: "sm"
						}),
						/* @__PURE__ */ F(y, {
							height: 32,
							width: 100,
							radius: "sm"
						})
					]
				}), /* @__PURE__ */ I(f, {
					gap: "sm",
					children: [/* @__PURE__ */ F(y, {
						height: 36,
						width: 200,
						radius: "sm"
					}), /* @__PURE__ */ F(y, {
						height: 36,
						width: 200,
						radius: "sm"
					})]
				})]
			}),
			/* @__PURE__ */ F(g, {
				withBorder: !0,
				children: /* @__PURE__ */ I(b, {
					gap: 0,
					children: [/* @__PURE__ */ F(i, {
						p: "md",
						style: { borderBottom: "1px solid var(--mantine-color-gray-3)" },
						children: /* @__PURE__ */ I(f, { children: [
							/* @__PURE__ */ F(y, {
								height: 16,
								width: 120
							}),
							/* @__PURE__ */ F(y, {
								height: 16,
								width: 100
							}),
							/* @__PURE__ */ F(y, {
								height: 16,
								width: 100
							}),
							/* @__PURE__ */ F(y, {
								height: 16,
								width: 100
							}),
							/* @__PURE__ */ F(y, {
								height: 16,
								width: 200
							})
						] })
					}), Array.from({ length: 8 }, (e, t) => /* @__PURE__ */ F(i, {
						p: "md",
						style: { borderBottom: "1px solid var(--mantine-color-gray-2)" },
						children: /* @__PURE__ */ I(f, {
							align: "flex-start",
							wrap: "nowrap",
							gap: "md",
							children: [
								/* @__PURE__ */ I(f, {
									gap: "sm",
									align: "flex-start",
									wrap: "nowrap",
									style: { flex: "0 0 24%" },
									children: [/* @__PURE__ */ F(y, {
										height: 40,
										width: 40,
										radius: "xl"
									}), /* @__PURE__ */ I(b, {
										gap: 2,
										style: { flex: 1 },
										children: [
											/* @__PURE__ */ F(y, {
												height: 16,
												width: "75%"
											}),
											/* @__PURE__ */ F(y, {
												height: 12,
												width: "60%"
											}),
											/* @__PURE__ */ F(y, {
												height: 12,
												width: "65%"
											})
										]
									})]
								}),
								/* @__PURE__ */ I(b, {
									gap: 2,
									style: { flex: "0 0 20%" },
									children: [
										/* @__PURE__ */ F(y, {
											height: 16,
											width: "80%"
										}),
										/* @__PURE__ */ F(y, {
											height: 12,
											width: "70%"
										}),
										/* @__PURE__ */ F(y, {
											height: 12,
											width: "60%"
										})
									]
								}),
								/* @__PURE__ */ F(i, {
									style: { flex: "0 0 12%" },
									children: /* @__PURE__ */ F(y, {
										height: 24,
										width: 80,
										radius: "xl"
									})
								}),
								/* @__PURE__ */ F(i, {
									style: { flex: "0 0 14%" },
									children: /* @__PURE__ */ F(y, {
										height: 16,
										width: 90
									})
								}),
								/* @__PURE__ */ F(i, {
									style: { flex: "0 0 30%" },
									children: /* @__PURE__ */ I(b, {
										gap: 2,
										children: [/* @__PURE__ */ I(f, {
											gap: 4,
											align: "center",
											children: [
												/* @__PURE__ */ F(y, {
													height: 24,
													width: 100,
													radius: "xl"
												}),
												/* @__PURE__ */ F(y, {
													height: 20,
													width: 20,
													radius: "xl"
												}),
												/* @__PURE__ */ F(y, {
													height: 20,
													width: 20,
													radius: "xl"
												}),
												/* @__PURE__ */ F(y, {
													height: 20,
													width: 20,
													radius: "xl"
												})
											]
										}), /* @__PURE__ */ F(y, {
											height: 12,
											width: "70%"
										})]
									})
								})
							]
						})
					}, t))]
				})
			}),
			/* @__PURE__ */ I(f, {
				justify: "space-between",
				children: [/* @__PURE__ */ F(y, {
					height: 16,
					width: 150
				}), /* @__PURE__ */ F(y, {
					height: 32,
					width: 200
				})]
			})
		]
	})
}), ct = () => /* @__PURE__ */ I(i, {
	style: {
		position: "relative",
		width: "100%",
		paddingTop: "20px"
	},
	children: [/* @__PURE__ */ F(i, { style: {
		position: "absolute",
		left: "24px",
		top: "40px",
		bottom: "20px",
		width: "2px",
		backgroundColor: "#e9ecef",
		zIndex: 0
	} }), /* @__PURE__ */ F(b, {
		gap: "lg",
		children: Array.from({ length: 4 }, (e, t) => /* @__PURE__ */ I(i, {
			style: {
				position: "relative",
				paddingLeft: "60px"
			},
			children: [/* @__PURE__ */ F(i, { style: {
				position: "absolute",
				left: "10px",
				top: "4px",
				width: "32px",
				height: "32px",
				borderRadius: "50%",
				backgroundColor: "#e9ecef",
				border: "3px solid white",
				zIndex: 1
			} }), /* @__PURE__ */ I(b, {
				gap: "sm",
				children: [/* @__PURE__ */ F(y, {
					height: 16,
					width: 160
				}), /* @__PURE__ */ I(g, {
					p: "md",
					withBorder: !0,
					children: [
						/* @__PURE__ */ I(f, {
							justify: "space-between",
							align: "flex-start",
							mb: "sm",
							children: [/* @__PURE__ */ F(y, {
								height: 20,
								width: 140
							}), /* @__PURE__ */ I(f, {
								gap: "xs",
								children: [/* @__PURE__ */ F(y, {
									height: 24,
									width: 70,
									radius: "sm"
								}), /* @__PURE__ */ F(y, {
									height: 24,
									width: 55,
									radius: "sm"
								})]
							})]
						}),
						/* @__PURE__ */ F(y, {
							height: 14,
							width: "60%",
							mb: "md"
						}),
						t === 1 || t === 3 ? /* @__PURE__ */ I(f, {
							gap: "xs",
							mb: "md",
							children: [
								/* @__PURE__ */ F(y, {
									height: 32,
									width: 120,
									radius: "sm"
								}),
								/* @__PURE__ */ F(y, {
									height: 32,
									width: 100,
									radius: "sm"
								}),
								/* @__PURE__ */ F(y, {
									height: 32,
									width: 110,
									radius: "sm"
								}),
								/* @__PURE__ */ F(y, {
									height: 32,
									width: 120,
									radius: "sm"
								})
							]
						}) : null,
						/* @__PURE__ */ F(y, {
							height: 14,
							width: "85%",
							mb: "xs"
						}),
						/* @__PURE__ */ F(y, {
							height: 14,
							width: "70%",
							mb: "md"
						}),
						t === 1 || t === 3 ? /* @__PURE__ */ F(y, {
							height: 20,
							width: 80
						}) : null
					]
				})]
			})]
		}, t))
	})]
}), $ = {
	modalContent: "_modalContent_1tu0o_2",
	modalHeader: "_modalHeader_1tu0o_10",
	modalBody: "_modalBody_1tu0o_17",
	headerSection: "_headerSection_1tu0o_22",
	modalTitle: "_modalTitle_1tu0o_28",
	headerContent: "_headerContent_1tu0o_34"
}, lt = ({ title: e, children: n, opened: r, onClose: a, showCloseButton: o = !0, headerActions: s, size: c = "lg", centered: l = !0, withOverlay: u = !0, padding: d = "xl", headerProps: p = {}, contentProps: h = {}, preventClose: g = !1, ..._ }) => {
	let v = () => {
		g || a();
	}, y = typeof e == "string" || typeof e == "number";
	return /* @__PURE__ */ F(m, {
		opened: r,
		onClose: v,
		size: c,
		centered: l,
		withOverlay: u,
		padding: 0,
		closeOnClickOutside: !g,
		closeOnEscape: !g,
		withCloseButton: !1,
		classNames: {
			content: $.modalContent,
			header: $.modalHeader,
			body: $.modalBody
		},
		..._,
		children: /* @__PURE__ */ I(b, {
			gap: 0,
			children: [(e || s || o) && /* @__PURE__ */ F(i, {
				p: d,
				pb: "md",
				className: $.headerSection,
				...p,
				children: /* @__PURE__ */ I(f, {
					justify: "space-between",
					align: "center",
					children: [/* @__PURE__ */ F("div", {
						className: $.headerContent,
						children: e && /* @__PURE__ */ F(P, { children: y ? /* @__PURE__ */ F(T, {
							order: 2,
							size: "h3",
							className: $.modalTitle,
							children: e
						}) : /* @__PURE__ */ F(i, {
							className: $.modalTitle,
							children: e
						}) })
					}), /* @__PURE__ */ I(f, {
						gap: "sm",
						children: [s, o && /* @__PURE__ */ F(t, {
							variant: "subtle",
							color: "gray",
							size: "lg",
							onClick: v,
							children: /* @__PURE__ */ F(G, { size: 18 })
						})]
					})]
				})
			}), /* @__PURE__ */ F(i, {
				p: d,
				...h,
				children: n
			})]
		})
	});
}, ut = ue;
export { Te as A, _e as B, Ie as C, ke as D, Ne as E, me as F, ue as G, de as H, pe as I, ve as L, Se as M, be as N, De as O, xe as P, fe as R, Re as S, Pe as T, J as U, ge as V, ye as W, We as _, ot as a, He as b, et as c, Ze as d, $e as f, Ge as g, Je as h, st as i, we as j, Ee as k, tt as l, Ye as m, lt as n, at as o, Xe as p, ct as r, it as s, ut as t, Qe as u, Ve as v, Fe as w, Be as x, Ue as y, he as z };

//# sourceMappingURL=atomic-Dj8hA6FD.js.map